module.exports = __webpack_public_path__ + "static/media/DTMThumb.4f36b561.png";